import { graphql } from 'gatsby'
import React from 'react'
import PartialFeatures from '../partials/twb_features'

interface TextWithIconDetailedProps {
  block: {
    _template: string
    icon: string
    image_alt_text: string
    pre_title: string
    text: string
    title: string
    items: {
      title: string
      subtitle: string
      icon_position: string
      icon: string
    }[]
  }
}
/**
 * A replacement for text_with_icon, because using icon_position also changes styles.
 * We don't want styles to change with position property.
 * @param param0
 * @returns
 */
const TextWithIconDetailed: React.FC<TextWithIconDetailedProps> = ({ block }) => {
  return (
    <section className={`block block__text_with_icon ${block._template}`}>
      <div className="image-wr">
        <img className="twb_icon" src={block.icon} alt={block.image_alt_text} />
      </div>
      <div className="content-wr">
        <h4 className="twb_title">{block.title} 
          <span className='twb_pre-title'>{block.pre_title}</span></h4>
        <div
          className="text-formatted"
          dangerouslySetInnerHTML={{ __html: block.text }}
        ></div>
        {block.items && (
          <div className="flex">
            <PartialFeatures
              block={{ ...block, _template: 'partial__features' }}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default TextWithIconDetailed

export const detailedQuery = graphql`
  fragment TextWithIconDetailedFragment on TextWithIconDetailed {
    _template
    settings {
      ...SettingsFragment
    }
    hide_on_mobile
    pre_title
    title
    text
    icon
    cta_field {
      ...CtaFieldFragment
    }
    items {
      title
      subtitle
      icon_position
      icon
    }
  }
`
